/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progate_Title1Inputs */

const zh_progate_title1 = /** @type {(inputs: Progate_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro 专属功能`)
};

const en_progate_title1 = /** @type {(inputs: Progate_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Feature`)
};

const es_progate_title1 = /** @type {(inputs: Progate_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Función Pro`)
};

/**
* | output |
* | --- |
* | "Pro Feature" |
*
* @param {Progate_Title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const progate_title1 = /** @type {((inputs?: Progate_Title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progate_Title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_progate_title1(inputs)
	if (locale === "en") return en_progate_title1(inputs)
	return es_progate_title1(inputs)
});
export { progate_title1 as "proGate_title" }